import React from 'react';
import styled from 'styled-components';

const ShimmerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const ShimmerBlock = styled.div`
  background-color: #e2e8f0;
  border-radius: 4px;
  animation: shimmer 2s infinite linear;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;

  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;

const ShimmerTitle = styled(ShimmerBlock)`
  height: 24px;
  width: 40%;
`;

const ShimmerSection = styled(ShimmerBlock)`
  height: 100px;
  width: 100%;
  margin-top: 0.5rem;
`;

const ShimmerPieChart = styled(ShimmerBlock)`
  height: 200px;
  width: 40%;
  border-right: 1px dotted #c6ccff;
  margin-right: 2rem;
`;

const ShimmerBarChart = styled(ShimmerBlock)`
  height: 200px;
  width: 60%;
`;

const ShimmerTableHeader = styled(ShimmerBlock)`
  height: 20px;
  width: 100%;
`;

const ShimmerTableRow = styled(ShimmerBlock)`
  height: 20px;
  width: 100%;
  &:not(:last-child) {
    margin-bottom: 1rem;
  }
`;

const ShimmerTable = styled.div`
  width: 100%;
`;

const ShimmerShareHoldings = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const ShimmerLoader = () => {
  return (
    <ShimmerWrapper>
      <ShimmerTitle />
      <ShimmerSection />

      <ShimmerTitle />
      <ShimmerSection />

      <ShimmerTitle />
      <ShimmerSection />

      <ShimmerTitle />
      <ShimmerShareHoldings>
        <ShimmerPieChart />
        <ShimmerBarChart />
      </ShimmerShareHoldings>

      <ShimmerTitle />
      <ShimmerTable>
        <ShimmerTableHeader />
        <ShimmerTableRow />
        <ShimmerTableRow />
        <ShimmerTableRow />
        <ShimmerTableRow />
      </ShimmerTable>
    </ShimmerWrapper>
  );
};

export default ShimmerLoader;
